export const manyProviderXlsxColumns = {
  cnpj_do_fornecedor: "",
  nome_do_representante_do_fornecedor: "",
  nome_do_fornecedor: "",
  nome_fantasia_do_fornecedor: "",
  email_do_fornecedor: "",
  senha_do_fornecedor: "",
  cpf_do_fornecedor: "",
  rg_do_fornecedor: "",
};

export type ManyProviderColumnsTypes = keyof typeof manyProviderXlsxColumns;
